import { render, staticRenderFns } from "./rectification.vue?vue&type=template&id=5747469c&scoped=true"
import script from "./rectification.vue?vue&type=script&lang=js"
export * from "./rectification.vue?vue&type=script&lang=js"
import style0 from "./rectification.vue?vue&type=style&index=0&id=5747469c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747469c",
  null
  
)

export default component.exports